export const USE_CASES = [
  {
    key: 'Invest in your business',
    value: 'use_case_business',
    icon: 'icon-equity',
    image: `https://hometap.dream.press/wp-content/uploads/invest-in-business-1.jpeg`,
  },
  {
    key: 'Pay off debt',
    value: 'use_case_debts',
    icon: 'icon-compensation',
    image: `https://hometap.dream.press/wp-content/uploads/UseCase_Lg_debt.jpg`,
  },
  {
    key: 'Fund an education',
    value: 'use_case_education',
    icon: 'icon-learning',
    image: `https://hometap.dream.press/wp-content/uploads/UseCase_Lg_education.jpg`,
  },
  {
    key: 'Buy another property',
    value: 'use_case_buy_home',
    icon: 'icon-house',
    image: `https://hometap.dream.press/wp-content/uploads/UseCase-second-prop-1.jpeg`,
  },
  {
    key: 'Renovate your home',
    value: 'use_case_renovate',
    icon: 'icon-renovate',
    image: `https://hometap.dream.press/wp-content/uploads/use_case_emergency.jpeg`,
  },
  {
    key: 'Retire comfortably',
    value: 'use_case_retirement',
    icon: 'icon-retire',
    image: `https://hometap.dream.press/wp-content/uploads/use_case_retirement.jpeg`,
  },
  {
    key: 'Diversify your portfolio',
    value: 'use_case_diversify',
    icon: 'icon-portfolio',
    image: `https://hometap.dream.press/wp-content/uploads/diversify_lg.png`,
  },
  {
    key: 'Pay for emergency expenses',
    value: 'use_case_emergency',
    icon: 'icon-healthcare',
    image: `https://hometap.dream.press/wp-content/uploads/emergency_lg-1.png`,
  },
  {
    key: 'Settle a divorce',
    value: 'use_case_divorce',
    icon: 'icon-divorce',
    image: `https://hometap.dream.press/wp-content/uploads/use_case_divorce.png`,
  },
  {
    key: 'Finance a car',
    value: 'use_case_finance_car',
    icon: 'icon-car',
    image: `https://hometap.dream.press/wp-content/uploads/finance_car.png`,
  },
  {
    key: 'Fund your family',
    value: 'use_case_fund_family',
    icon: 'icon-fund-fam',
    image: `https://hometap.dream.press/wp-content/uploads/life-event_lg.png`,
  },
  {
    key: 'Other',
    value: 'use_case_other',
    icon: 'icon-other',
    image: `https://hometap.dream.press/wp-content/uploads/use_case_other.png`,
  },
];
